import httpManager from "../../../../shared/utils/httpManager";

/**
 * Obtener contacto.
 *
 * @param {Number} id
 * @return {Promise<Object>} Contacto
 */
export async function fetchRecordsClient(id) {
  const url = `/contacts/clients/${id}/ticket-history/`;
  const response = await httpManager.get(url);

  return response.data;
}
